// @flow
import get from 'lodash/get';
import type { CarsQuery, CarsFilters } from '../../types';
import mapBoolean from './mapBoolean';

function mapFilters(filters): CarsFilters {
  return {
    region: filters.region,
    city: filters.city,
    make: filters.make,
    model: filters.model,
    priceMin: filters.price_min,
    priceMax: filters.price_max,
    yearMin: filters.year_min,
    yearMax: filters.year_max,
    mileageMin: filters.mileage_min,
    mileageMax: filters.mileage_max,
    doorsMin: filters.doors_min,
    doorsMax: filters.doors_max,
    carType: filters.car_type,
    transmission: filters.transmission,
    fuel: filters.fuel,
    photos: mapBoolean(filters.photos),
    decreasePrice: mapBoolean(filters.decrease_price),
  };
}

export default function(apiSearchNotification: Object): CarsQuery {
  const filters = get(apiSearchNotification, 'attributes.query.filters', {});

  return {
    search: get(apiSearchNotification, 'attributes.query.what', ''),
    verticalProperties: {
      // No type id for cars
    },
    filters: mapFilters(filters),
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/shared/SearchNotifications/adapters/subscriptionQueryMapper/carsQueryMapper.js